export default __webpack_public_path__ + "static/cube-d603fb41c153f5d32d0b6b16965aba1d.png";